import React from 'react';

const Stage3 = (props) => {
    return (
        <div>Stage 3</div>
    );
}

export default Stage3;